module.exports = __webpack_public_path__ + "static/media/42.59f9faa7.jpg";